import template from './editProfile.html';
import controller from './editProfile.controller';
import './editProfile.scss';

let editProfileComponent = {
  bindings: {},
  template,
  controller
};

export default editProfileComponent;



// WEBPACK FOOTER //
// ./client/app/components/editProfile/editProfile.component.js